import React, { ChangeEvent } from "react";
import { FormErrorMessage } from "../../components";
import { RequestFormInitDataType } from "../../redux/slices/OnBoardingSlice";

import NumberFormat from "react-number-format";

const OhipNumberField = ({
  field,
  onChange = () => {},
  onBlur = () => {},
  isError = false,
  isTransparent = false,
}: {
  field: RequestFormInitDataType;
  onChange?: (value: string) => void;
  onBlur?: (value: string) => void;
  isError?: boolean;
  isTransparent?: boolean;
}) => {
  return (
    <div className="py-0.5" key={field.id}>
      <label className="text-sm text-docsigna-blue-dark font-medium block w-full mb-1">
        {field.label}
        {field.required && <span className="text-red-500">*</span>}
      </label>
      {/* Hidden honeypot field to confuse browser autofill */}
      <input type="text" name="cc-number" style={{ display: "none" }} tabIndex={-1} autoComplete="off" />
      <NumberFormat
        value={field.value}
        isNumericString
        format={"#### ### ###"}
        placeholder="Health Card #"
        displayType="input"
        inputMode="numeric"
        name={`hc_${Date.now()}`}
        id="provincial-health-id"
        autoComplete="one-time-code"
        data-form-type="other"
        data-lpignore="true"
        data-1p-ignore="true"
        aria-autocomplete="none"
        className={`general-ohip h-[44.5px] ${isTransparent ? "!bg-transparent" : "!bg-white"}`}
        onValueChange={values => {
          onChange(values.value);
        }}
        onBlur={(e: ChangeEvent<HTMLInputElement>) => {
          onBlur(e.target.value);
        }}
      />
      {isError && <FormErrorMessage text={field.errorMesage} />}
    </div>
  );
};

export default OhipNumberField;
